import formatDate from './../utils/formatDate';
import { apiFetch } from './apiFetch';

const dashboardService = {
  async getRecords(filters = {}) {
    const url = `${process.env.REACT_APP_API_URL}/GetRecordsReviewedByUser`;
    const formData = new FormData();

    const dayBoundsUTC = (d) => ({
      fromISO: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0,0,0,0)).toISOString(),
      toISO:   new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 23,59,59,999)).toISOString(),
    });

    function mergeDateAndTime(date, time) {
      if (!(date instanceof Date) || isNaN(date)) {
        console.warn('Invalid date passed:', date);
        return null;
      }

      const merged = new Date(date);
      if (time) {
        const [hours, minutes] = time.split(':').map(Number);
        merged.setHours(hours || 0, minutes || 0, 0, 0);
      }
      return merged;
    }

    if (filters.dateRange?.[0]?.startDate) {
      const fromDateTime = mergeDateAndTime(filters.dateRange[0].startDate, filters.startTime);
      formData.append('FromDate', formatDate(fromDateTime));
    }

    if (filters.dateRange?.[0]?.endDate) {
      const toDateTime = mergeDateAndTime(filters.dateRange[0].endDate, filters.endTime);
      formData.append('ToDate', formatDate(toDateTime));
    }

    formData.append('SortColumn', filters.sortColumn || 1);
    formData.append('sortDirection', filters.sortDirection || "ASC");

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getRecordsProcessedByPeriod() {
    const url = `${process.env.REACT_APP_API_URL}/Dashboard/GetRecordsProcessedByPeriod`;

    const response = await apiFetch(url, {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getDailyReviewCounts(from, to) {
  const params = new URLSearchParams({
    from: from.toISOString(),
    to:   to.toISOString()
  });

  const url = `${process.env.REACT_APP_API_URL}/Dashboard/GetDailyReviewCounts?${params}`;

  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',    
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
},

async getPendingReviewsReport() {
  const url = `${process.env.REACT_APP_API_URL}/Dashboard/GetPendingReviewsReport`;
  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
},
async getAnalystReport(username, from, to) {

  const dayBoundsUTC = (f, t) => ({
    fromISO: new Date(Date.UTC(f.getFullYear(), f.getMonth(), f.getDate(), 0,0,0,0)).toISOString(),
    toISO:   new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), 23,59,59,999)).toISOString(),
  });
  const url = `${process.env.REACT_APP_API_URL}/AnalystReport/GetAnalystReport`;
  const { fromISO, toISO } = dayBoundsUTC(from, to);
  const bodyObj = {fromDate: fromISO,toDate: toISO,username};
  const response = await apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(bodyObj)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
},

async GetAllAnalystsReport(from, to) {
  const url = `${process.env.REACT_APP_API_URL}/AnalystReport/GetAllAnalystsReport`;
  const dayBoundsUTC = (f, t) => ({
    fromISO: new Date(Date.UTC(f.getFullYear(), f.getMonth(), f.getDate(), 0,0,0,0)).toISOString(),
    toISO:   new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), 23,59,59,999)).toISOString(),
  });
  const { fromISO, toISO } = dayBoundsUTC(from, to);
  const bodyObj = {fromDate: fromISO,toDate: toISO};
  const response = await apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(bodyObj)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
},

async GetAllPcRecordsReviewedByAllUsers(from, to) {
  const url = `${process.env.REACT_APP_API_URL}/AnalystReport/GetAllPcRecordsReviewedByAllUsers`;
  const dayBoundsUTC = (f, t) => ({
    fromISO: new Date(Date.UTC(f.getFullYear(), f.getMonth(), f.getDate(), 0,0,0,0)).toISOString(),
    toISO:   new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), 23,59,59,999)).toISOString(),
  });
  const { fromISO, toISO } = dayBoundsUTC(from, to);
  const bodyObj = {fromDate: fromISO,toDate: toISO};
  const response = await apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(bodyObj)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}
};

export default dashboardService;
